export const data = [
    {
        id: 1,
        url: "https://media-rockstargames-com.akamaized.net/tina-uploads/posts/ak759k91592728/26f0a119854a14012e04a9477b89fd6c416812c6.jpg",
        game_title: "Grand Theft Auto Online",
        title: "The Contract-Out Now"
    },
    // {
    //     id: 2,
    //     url: "https://media-rockstargames-com.akamaized.net/tina-uploads/posts/51ko98182a41o9/f3edd488fa294e6a10d2f3af09f1fcd8dcf3f6dd.jpg",
    //     game_title: "Grand Theft Auto Online",
    //     title: "Gta Online:The Contract-Coming December 15"
    // },
    // {
    //     id: 3,
    //     url: "https://media-rockstargames-com.akamaized.net/tina-uploads/posts/3933o7ko43o839/852cd36dd27f7a71143a5fb17008e9d4aa9fc944.jpg",
    //     game_title: "Grand Theft Auto:The Trilogy-The Definitive Edition",
    //     title: "Grand Theft Auto:The Trilogy-Definitive Edition Trailer"
    // },
    // {
    //     id: 4,
    //     url: "https://media-rockstargames-com.akamaized.net/tina-uploads/posts/k43328ka511549/d63bcd42d533ae9ca392a4cfd2a5d8c37d55a9f3.jpg",
    //     game_title: "Red Dead Online",
    //     title: "The Halloween Pass 2"
    // }
]